import React from 'react';
import { Link } from 'react-router-dom';
import { BOOKING_URL } from './siteConfig';
import './Footer.css';

// Custom link component that scrolls to top on click
const ScrollToTopLink: React.FC<{to: string, children: React.ReactNode, className?: string}> = ({ to, children, className }) => {
  const handleClick = () => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  };

  return (
    <Link to={to} onClick={handleClick} className={className}>
      {children}
    </Link>
  );
};

// minimal: trademark line, copyright and legal links only, for funnel pages
const Footer: React.FC<{ minimal?: boolean }> = ({ minimal = false }) => {
  return (
    <footer className={`footer${minimal ? ' footer-minimal' : ''}`}>
      {!minimal && (
        <div className="footer-container">
          <div className="footer-section footer-logo-section">
            <img src={require('./Images/Logo-white-text-no-tagline.png')} alt="Cadence IO Logo" className="footer-logo" />
          </div>
        
          <div className="footer-section footer-nav-section">
            <nav className="footer-nav">
              <ScrollToTopLink to="/">Home</ScrollToTopLink>
              <ScrollToTopLink to="/about">About</ScrollToTopLink>
              <a href="https://app.cadenceio.com/auth/login">Log In</a>
            </nav>
          </div>

          <div className="footer-section footer-buttons-section">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-btn">
              Book a call
            </a>
          </div>
        </div>
      )}

      <p className="footer-trademark">Platform names are trademarks of their respective owners. Cadence IO is not affiliated with, endorsed by, or a partner of any of them.</p>

      <div className="footer-bottom">
        <p className="footer-copyright">© {new Date().getFullYear()} Cadence IO. All rights reserved.</p>
        <div className="footer-legal">
          <ScrollToTopLink to="/privacy-policy">Privacy Policy</ScrollToTopLink>
          <ScrollToTopLink to="/terms-of-service">Terms of Service</ScrollToTopLink>
        </div>
      </div>
    </footer>
  );
};

export default Footer;